var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { useCallback, useEffect, useState } from "react";
import { getUserState, updateUserState, } from "@/api/userState/userState";
// Read/write a single key in the per-user server-side user_state bag. Mirrors
// hub-ui-v2's hook of the same name, but without react-query (this repo has no
// query cache), so it loads once on mount and writes optimistically.
export function useUserStateKey(key, defaultValue) {
    var _a = __read(useState(), 2), state = _a[0], setState = _a[1];
    var _b = __read(useState(true), 2), isLoading = _b[0], setIsLoading = _b[1];
    useEffect(function () {
        var active = true;
        getUserState()
            .then(function (next) {
            if (active) {
                setState(next);
            }
        })
            .catch(function () {
            if (active) {
                setState({});
            }
        })
            .finally(function () {
            if (active) {
                setIsLoading(false);
            }
        });
        return function () {
            active = false;
        };
    }, []);
    var setValue = useCallback(function (value) {
        var _a;
        var next = __assign(__assign({}, (state !== null && state !== void 0 ? state : {})), (_a = {}, _a[key] = value, _a));
        setState(next);
        // Fire-and-forget: the optimistic local update already hides the UI.
        updateUserState(next).catch(function () { });
    }, [state, key]);
    return {
        isLoading: isLoading,
        value: state ? state[key] : defaultValue,
        setValue: setValue,
    };
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidXNlVXNlclN0YXRlS2V5LmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsidXNlVXNlclN0YXRlS2V5LnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7OztBQUFBLE9BQU8sRUFBRSxXQUFXLEVBQUUsU0FBUyxFQUFFLFFBQVEsRUFBRSxNQUFNLE9BQU8sQ0FBQztBQUV6RCxPQUFPLEVBQ0wsWUFBWSxFQUNaLGVBQWUsR0FFaEIsTUFBTSwyQkFBMkIsQ0FBQztBQUVuQyw4RUFBOEU7QUFDOUUsK0VBQStFO0FBQy9FLHFFQUFxRTtBQUNyRSxNQUFNLFVBQVUsZUFBZSxDQUFJLEdBQVcsRUFBRSxZQUFnQjtJQUN4RCxJQUFBLEtBQUEsT0FBb0IsUUFBUSxFQUFhLElBQUEsRUFBeEMsS0FBSyxRQUFBLEVBQUUsUUFBUSxRQUF5QixDQUFDO0lBQzFDLElBQUEsS0FBQSxPQUE0QixRQUFRLENBQUMsSUFBSSxDQUFDLElBQUEsRUFBekMsU0FBUyxRQUFBLEVBQUUsWUFBWSxRQUFrQixDQUFDO0lBRWpELFNBQVMsQ0FBQztRQUNSLElBQUksTUFBTSxHQUFHLElBQUksQ0FBQztRQUVsQixZQUFZLEVBQUU7YUFDWCxJQUFJLENBQUMsVUFBQyxJQUFJO1lBQ1QsSUFBSSxNQUFNLEVBQUU7Z0JBQ1YsUUFBUSxDQUFDLElBQUksQ0FBQyxDQUFDO2FBQ2hCO1FBQ0gsQ0FBQyxDQUFDO2FBQ0QsS0FBSyxDQUFDO1lBQ0wsSUFBSSxNQUFNLEVBQUU7Z0JBQ1YsUUFBUSxDQUFDLEVBQUUsQ0FBQyxDQUFDO2FBQ2Q7UUFDSCxDQUFDLENBQUM7YUFDRCxPQUFPLENBQUM7WUFDUCxJQUFJLE1BQU0sRUFBRTtnQkFDVixZQUFZLENBQUMsS0FBSyxDQUFDLENBQUM7YUFDckI7UUFDSCxDQUFDLENBQUMsQ0FBQztRQUVMLE9BQU87WUFDTCxNQUFNLEdBQUcsS0FBSyxDQUFDO1FBQ2pCLENBQUMsQ0FBQztJQUNKLENBQUMsRUFBRSxFQUFFLENBQUMsQ0FBQztJQUVQLElBQU0sUUFBUSxHQUFHLFdBQVcsQ0FDMUIsVUFBQyxLQUFROztRQUNQLElBQU0sSUFBSSx5QkFBUSxDQUFDLEtBQUssYUFBTCxLQUFLLGNBQUwsS0FBSyxHQUFJLEVBQUUsQ0FBQyxnQkFBRyxHQUFHLElBQUcsS0FBSyxNQUFFLENBQUM7UUFDaEQsUUFBUSxDQUFDLElBQUksQ0FBQyxDQUFDO1FBQ2YscUVBQXFFO1FBQ3JFLGVBQWUsQ0FBQyxJQUFJLENBQUMsQ0FBQyxLQUFLLENBQUMsY0FBTyxDQUFDLENBQUMsQ0FBQztJQUN4QyxDQUFDLEVBQ0QsQ0FBQyxLQUFLLEVBQUUsR0FBRyxDQUFDLENBQ2IsQ0FBQztJQUVGLE9BQU87UUFDTCxTQUFTLFdBQUE7UUFDVCxLQUFLLEVBQUUsS0FBSyxDQUFDLENBQUMsQ0FBRSxLQUFLLENBQUMsR0FBRyxDQUFPLENBQUMsQ0FBQyxDQUFDLFlBQVk7UUFDL0MsUUFBUSxVQUFBO0tBQ1QsQ0FBQztBQUNKLENBQUMifQ==